import React from 'react';
import PropTypes from 'prop-types';
import ReportWrapper from 'components/ReportWrapper';
import ReportViewer from 'ReportViewer/layout';
import {intlShape, injectIntl} from 'react-intl';

class Output extends React.Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
  };

  render() {
    return <ReportWrapper>
      <ReportViewer language={this.props.intl.locale} data={this.props.data} />
    </ReportWrapper>;
  }
}

export default injectIntl(Output);
